import { withInstall } from '@visual-design/utils'
import Icon from './src/icon.vue'

export const VIcon = withInstall(Icon)

export default VIcon
